import React from "react";
import emptyStateStyles from "../../css/DataState.module.css";
import emptyState from "../../assets/icons/Empty State.png";
import { AddRegisterButton } from "../../fixedassetelements/button/Button";

const DataState = ({onAdd}) => {
  return (
    <div className={emptyStateStyles.contentContainer}>
      <div className={emptyStateStyles.container}>
        <div className={emptyStateStyles.content}>
          <img src={emptyState} alt="empty" className={emptyStateStyles.pointer} />
          <p className={emptyStateStyles.message}>
            <span className={emptyStateStyles.topText}>Nothing here yet</span>
            <br />
            <span className={emptyStateStyles.bottomText}>
              Add a register to get started
            </span>
          </p>
          <div>
            <AddRegisterButton onClick={onAdd}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataState;
